import { COLOR_YELLOW_300 } from '@alltrails/denali/tokens';
import { createCircleMarker, getCircleMarkerSizeWithoutShadow } from './svgMarkerComponents';

const innerDiameter = 16;
export const svgSizeWithoutShadow = getCircleMarkerSizeWithoutShadow(innerDiameter);
const svg = createCircleMarker({ imageName: 'user-waypoint', innerDiameter, innerFill: COLOR_YELLOW_300 });

export default svg;
